import React from 'react';

const TopBanner = () => {
    return (
        <div className="top-header-banner-wrapper">
            <a href="#" className="top-header-banner">
                <img src="./assets/sample-image/topBanner.gif" className="banner" alt="banner"/>
            </a>
        </div>
    );
};

export default TopBanner;
